import { Component, Input, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { NgIf } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-video-player',
    templateUrl: './video-player.component.html',
    styleUrls: ['./video-player.component.scss'],
    standalone: true,
    imports: [NgIf]
})
export class VideoPlayerComponent implements OnChanges {
    constructor(private sanitizer: DomSanitizer) { }
    safeUrl!: SafeResourceUrl;
    @Input() videoMeta: any; // { type: 'file' | 'youtube' | 'vimeo', url: string, id?: string }
    @Input() videoError: string = '';
    @ViewChild('videoPlayer') videoPlayer!: ElementRef;
    public show: boolean = false;

    public youtubeEmbedFailed: boolean = false;

    ngOnInit(): void {
        this.buildSafeUrl();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['videoMeta'] || changes['videoError']) {
            // Reset transient embed failure state when input video changes.
            this.youtubeEmbedFailed = false;
            this.buildSafeUrl();
        }
    }

    private buildSafeUrl(): void {
        if (this.videoMeta) {
            if (this.videoMeta.type === 'youtube' && this.videoMeta.id) {
                this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                    `https://www.youtube-nocookie.com/embed/${this.videoMeta.id}?rel=0`
                );
            } else if (this.videoMeta.type === 'vimeo' && this.videoMeta.id) {
                this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                    `https://player.vimeo.com/video/${this.videoMeta.id}`
                );
            } else if (this.videoMeta.type === 'file' && this.videoMeta.url) {
                this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoMeta.url);
            } else {
                this.safeUrl = '';
            }
        } else {
            this.safeUrl = '';
        }
        // Ensure safeUrl is never null or undefined
        if (!this.safeUrl) {
            this.safeUrl = '';
        }
    }
    // Called when iframe fails to load (YouTube embed restriction)
    onYouTubeEmbedError() {
        this.youtubeEmbedFailed = true;
    }

    pauseVideo() {
        if (this.videoPlayer && this.videoPlayer.nativeElement) {
            this.videoPlayer.nativeElement.play();
            setTimeout(() => {
                this.videoPlayer.nativeElement.pause();
                if (this.videoPlayer.nativeElement.paused) {
                    this.show = !this.show;
                }
            }, 5000);
        }
    }

    closebutton() {
        this.show = !this.show;
        if (this.videoPlayer && this.videoPlayer.nativeElement) {
            this.videoPlayer.nativeElement.play();
        }
    }
}   
